import { Text } from '@fluentui/react'
import { QuarterResult } from '../../api/models'
import { describeExcludedUsers } from './krFormat'
import { MUTED_TEXT } from './krStyles'

type ExcludedUsersNoteProps = {
  quarter: QuarterResult
}

const ExcludedUsersNote = ({ quarter }: ExcludedUsersNoteProps) => {
  const note = describeExcludedUsers(quarter)
  if (note === null) return null
  return (
    <Text variant="xSmall" styles={MUTED_TEXT}>
      {note}
    </Text>
  )
}

export default ExcludedUsersNote
